module.exports = __webpack_public_path__ + "media/wood_5.517bf333.webm";